// extracted by mini-css-extract-plugin
export default {"lastUpdatedDiv":"LastUpdated_lastUpdatedDiv__tYNyI","lastUpdatedLabel":"LastUpdated_lastUpdatedLabel__3GeaV"};